var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4264FD",
  fillRule: "evenodd",
  d: "M13.246 2.014v-.89c0-.62-.759-1.124-1.694-1.124H7.447c-.935 0-1.694.504-1.694 1.124v.854l.001.036h-4.64A1.12 1.12 0 0 0 0 3.14v10.737C0 14.496.5 15 1.115 15h16.77A1.12 1.12 0 0 0 19 13.876V3.139c0-.621-.5-1.125-1.115-1.125zm-7.6 6.493c0 2.147 1.726 3.887 3.854 3.887s3.854-1.74 3.853-3.887c0-2.145-1.724-3.886-3.853-3.886s-3.855 1.74-3.855 3.886Zm6.82.001c0 1.652-1.327 2.99-2.966 2.99-1.637 0-2.965-1.338-2.965-2.99s1.328-2.99 2.965-2.99c1.639 0 2.966 1.338 2.966 2.99",
  clipRule: "evenodd"
})));
export default SvgIconPhoto;